import { BusinessList } from '@/modules/Business/components/List'
import { DayOffList } from '@/modules/Dayoffs/components/List'
import WorkDayList from '@/modules/WorkDay/components/List'
import OncallList from './OncallList'

export const tabs = [
    {
        label: 'workday-account-list',
        value: 'workdays',
        component: <WorkDayList hideHeader />,
    },
    {
        label: 'day-off-account',
        value: 'dayoffs',
        component: <DayOffList pageType="member" hideHeader />,
    },
    {
        label: 'business',
        value: 'business',
        component: <BusinessList pageType="member" hideHeader />,
    },
    {
        label: 'oncall',
        value: 'oncall',
        component: <OncallList />,
    },
]
